<template>
    <header class="header d-blue-bg" :class="{ 'header--shrunk': isScrolled }">
        <!-- Header Top -->
        <div class="header-top">
            <div class="container">
                <div class="header-inner">
                    <div class="row align-items-center">
                        <div class="col-xl-6 col-lg-7">
                            <div class="header-inner-start">


                                <div class="support d-none d-sm-block">
                                    <p>Need Help? <a :href="'tel:0112984988'">011 2098 778</a></p>
                                </div>
                            </div>
                        </div>
                        <div class="col-xl-6 col-lg-5 d-none d-lg-block">
                            <div class="header-inner-end text-md-end">
                                <div class="ovic-menu-wrapper">
                                    <ul>
                                        <li><router-link to="/about">About Us</router-link></li>
                                        <li><router-link to="/order-tracking">Order Tracking</router-link></li>
                                        <li><router-link to="/contact">Contact Us</router-link></li>
                                        <li><router-link to="/faq">FAQs</router-link></li>
                                    </ul>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>

        <!-- header mid -->

        <div class="header-mid header-mid--shop">
            <div class="container">
                <div class="header-mid-inner header-mid-inner--shop">
                    <div class="row align-items-center">
                        <div class="col-xl-3 col-lg-3 col-md-4 col-sm-4">
                            <div v-if="!style_3" class="header__info">
                                <div class="logo">
                                    <router-link to="/" class="logo-image">
                                        <img :src="logo" alt="logo">
                                    </router-link>
                                </div>
                            </div>
                            <div v-if="style_3" class="header__info header__info-2">
                                <div class="logo logo-3">
                                    <router-link to="/" class="logo-image">
                                        <img src="/images/logo/logo1.svg" alt="logo">
                                    </router-link>
                                </div>
                                <div class="side-menu mr-20">
                                    <button @click="handleOpenSidebar" type="button"
                                        class="side-menu-btn offcanvas-toggle-btn"><i class="fas fa-bars"></i></button>
                                </div>
                            </div>
                        </div>

                        <div class="col-xl-5 col-lg-4 d-none d-lg-block">
                            <div class="header__search">
                                <form @submit.prevent="handleSubmit">
                                    <div class="header__search-box">
                                        <input
                                            :class="`search-input ${style_2 ? 'search-input-2' : ''}`"
                                            type="text"
                                            placeholder="Search For Products"
                                            v-model="searchText"
                                            @input="handleSuggestInput"
                                            @focus="handleSuggestFocus"
                                            @blur="handleSuggestBlur"
                                            @keydown.down.prevent="suggestMove(1)"
                                            @keydown.up.prevent="suggestMove(-1)"
                                            @keydown.enter.prevent="handleEnterFromSuggest"
                                        />
                                        <button
                                            :class="`button ${style_2 ? 'button-2' : ''} ${style_3 ? 'button-3' : ''}`"
                                            type="submit">
                                            <i class="fas fa-search"></i>
                                        </button>
                                    </div>
                                    <div
                                        v-if="showSuggestions && suggestions.length"
                                        class="header-search-suggestions"
                                        @mousedown.prevent
                                    >
                                        <div
                                            v-for="(s, idx) in suggestions"
                                            :key="s.id"
                                            class="suggestion-item"
                                            :class="{ active: idx === suggestIndex }"
                                            @click="selectSuggestion(s)"
                                        >
                                            <div class="suggestion-title">{{ s.product_name }}</div>
                                            <div class="suggestion-sub" v-if="s.product_code">{{ s.product_code }}</div>
                                        </div>
                                    </div>
                                    <div class="header__search-cat">
                                        <ui-nice-select :options="category_options"
                                            :model-value="category_value"
                                            name="Department"
                                            placeholder="All departments"
                                            :default-current="0"
                                            @onChange="changeHandler" />
                                    </div>
                                </form>
                            </div>
                        </div>
                        <div class="col-xl-4 col-lg-5 col-md-8 col-sm-8 header-mid__actions-col">
                            <div class="header-action header-action--with-theme header-action--shop">
                                <div class="block-userlink">
                                    <router-link :class="`icon-link ${style_2 ? 'icon-link-2' : ''}`" v-if="isLoggedIn"
                                        to="/my-account">
                                        <i class="flaticon-user"></i>
                                        <span class="text welcome-text">
                                            <span class="sub">Welcome,</span>
                                            <span class="welcome-username">{{ user.name }}</span>
                                        </span>
                                    </router-link>
                                    <router-link :class="`icon-link ${style_2 ? 'icon-link-2' : ''}`" v-else
                                        to="/login">
                                        <i class="flaticon-user"></i>
                                        <span class="text">
                                            <span class="sub">Login </span>
                                        </span>
                                    </router-link>
                                </div>

                                <!-- <div class="block-wishlist action">
                                    <router-link :class="`icon-link ${style_2 ? 'icon-link-2' : ''}`" to="/wishlist">
                                        <i class="flaticon-heart"></i>
                                        <span class="text">
                                            <span class="sub">Favorite</span>
                                            My Wishlist
                                        </span>
                                    </router-link>
                                </div> -->

                                <div class="header-action__theme-center">
                                    <navbar-theme-switcher variant="nav-mid-light" />
                                </div>

                                <div class="block-cart action">
                                    <router-link :class="`icon-link icon-link--cart ${style_2 ? 'icon-link-2' : ''}`" to="/cart">
                                        <span class="shop-cart-svg-wrap">
                                            <svg class="shop-cart-svg" viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg" aria-hidden="true">
                                                <path d="M3 4h3.2l1.4 3M7.6 7l3.4 11.5a2 2 0 0 0 1.92 1.42h10.04a2 2 0 0 0 1.92-1.42l2.42-7.5H7.6Z"
                                                    stroke="currentColor" stroke-width="1.7" stroke-linecap="round" stroke-linejoin="round" />
                                                <circle cx="12.5" cy="25.5" r="2" stroke="currentColor" stroke-width="1.7" />
                                                <circle cx="22.5" cy="25.5" r="2" stroke="currentColor" stroke-width="1.7" />
                                            </svg>
                                            <span class="shop-cart-badge" aria-label="Cart count">
                                                {{ cartStore.totalPriceQuantity.quantity }}
                                            </span>
                                        </span>
                                        <span class="text cart-text">
                                            <span class="sub">My Cart</span>
                                            <span class="cart-amount">LKR {{ cartStore.totalPriceQuantity.total.toFixed(2) }}</span>
                                        </span>
                                    </router-link>
                                    <div class="cart">
                                        <header-cart-mini />
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>

        <!-- header mid -->

        <div class="header__bottom">
            <div class="container">
                <div class="row g-0 align-items-center">
                    <div class="col-lg-3">

                        <div class="cat__menu-wrapper side-border d-none d-lg-block" @click.stop>
                            <div class="cat-toggle">
                                <button @click.stop="toggleCateMenu" type="button"
                                    class="cat-toggle-btn cat-toggle-btn-1">
                                    <i class="fas fa-bars"></i> Shop by department
                                </button>
                                <div class="cat__menu" v-show="cate_menu" @click.stop>
                                    <nav id="mobile-menu">
                                        <header-category :categories="category_data"></header-category>
                                    </nav>
                                </div>
                            </div>
                        </div>

                    </div>

                    <div class="col-lg-9 col-md-6 col-3">
                        <div class="header__bottom-left d-flex d-xl-block align-items-center">
                            <div class="side-menu d-lg-none mr-20">
                                <button @click="isSidebarOpen = !isSidebarOpen" type="button"
                                    class="side-menu-btn offcanvas-toggle-btn">
                                    <i class="fas fa-bars"></i>
                                </button>
                            </div>
                            <div class="main-menu d-none d-lg-block">
                                <header-nav-menu></header-nav-menu>
                            </div>
                        </div>
                    </div>

                    <!-- <div class="col-lg-3 col-md-6 col-9">
                        <div class="shopeing-text text-sm-end">
                            <p>Spend $120 more and get free shipping!</p>
                        </div>
                    </div> -->
                </div>
            </div>
        </div>
    </header>
</template>

<script>
//import logo from '@/assets/logo/logo1.svg'
import logo from '@/assets/img/logo.png'
import HeaderNavMenu from '@/components/test/HeaderNavMenu.vue'
import UiNiceSelect from '@/components/ui/nice-select.vue'
import HeaderCartMini from '@/components/test/header-cart-mini.vue'
import NavbarThemeSwitcher from '@/components/header/navbar-theme-switcher.vue'
import HeaderCategory from '@/components/test/header-category.vue'
import { useCartStore } from '@/stores/useCartStore'
import { ref, computed, watch, onMounted, onBeforeUnmount } from 'vue'

export default {
    components: {
        HeaderNavMenu,
        UiNiceSelect,
        HeaderCategory,
        HeaderCartMini,
        NavbarThemeSwitcher,
    },
    name: "HeaderOne",
    props: {
        /** Alternate header styling variants (parity with legacy header-mid.vue) */
        style_2: {
            type: Boolean,
            default: false,
        },
        style_3: {
            type: Boolean,
            default: false,
        },
    },
    emits: ['openOffcanvas'],
    setup() {
        const user = ref(JSON.parse(localStorage.getItem('user')) || null) // Get user from localStorage
        const isLoggedIn = computed(() => {
            return !!user.value // Check if the user data exists
        })

        watch(() => localStorage.getItem('user'), (newVal) => {
            user.value = JSON.parse(newVal)
        })
        const cartStore = useCartStore()

        const cate_menu = ref(false)

        // Toggle menu when clicking the button
        const toggleCateMenu = () => {
            cate_menu.value = !cate_menu.value
        }

        // Close menu when clicking outside
        const closeCateMenu = (event) => {
            const menuWrapper = document.querySelector('.cat__menu-wrapper')
            if (menuWrapper && !menuWrapper.contains(event.target)) {
                cate_menu.value = false
            }
        }

        // Shrink-on-scroll: rAF-throttled + hysteresis so scroll position doesn't
        // oscillate around a single threshold (which caused flicker / "jumping").
        const isScrolled = ref(false)
        // Wider band so scrollY doesn’t flirt with thresholds when the header height changes.
        const SCROLL_SHRINK_AT = 96
        const SCROLL_EXPAND_AT = 20
        let scrollRaf = 0

        const applyShrunkFromScrollY = (y) => {
            if (y >= SCROLL_SHRINK_AT) {
                if (!isScrolled.value) isScrolled.value = true
            } else if (y <= SCROLL_EXPAND_AT) {
                if (isScrolled.value) isScrolled.value = false
            }
        }

        const onWindowScroll = () => {
            if (scrollRaf) return
            scrollRaf = window.requestAnimationFrame(() => {
                scrollRaf = 0
                applyShrunkFromScrollY(window.scrollY || window.pageYOffset || 0)
            })
        }

        // Attach and detach global event listeners
        onMounted(() => {
            document.addEventListener('click', closeCateMenu)
            window.addEventListener('scroll', onWindowScroll, { passive: true })
            applyShrunkFromScrollY(window.scrollY || window.pageYOffset || 0)
        })

        onBeforeUnmount(() => {
            document.removeEventListener('click', closeCateMenu)
            window.removeEventListener('scroll', onWindowScroll)
            if (scrollRaf) {
                window.cancelAnimationFrame(scrollRaf)
                scrollRaf = 0
            }
        })



        return {
            user,
            isLoggedIn,
            cartStore,
            logo,
            cate_menu,
            toggleCateMenu,
            isScrolled

        }
    },
    data() {
        return {
            isSidebarOpen: false,
            category_data: [],
            searchText: '',
            category_value: '',
            category_options: [],
            suggestions: [],
            showSuggestions: false,
            suggestIndex: -1,
            suggestTimer: null,
        }
    },
    methods: {
        handleOpenSidebar() {
            this.isSidebarOpen = true
            this.$emit('openOffcanvas')
        },
        /** Mega menu (/web-item-categories) + search department filter (/website-categories). */
        async fetchCategories() {
            try {
                const [menuRes, deptRes] = await Promise.all([
                    this.$axios.get('/web-item-categories'),
                    this.$axios.get('/website-categories'),
                ])
                const menuRows = Array.isArray(menuRes.data) ? menuRes.data : []
                this.category_data = menuRows

                const depts = Array.isArray(deptRes.data) ? deptRes.data : []
                this.category_options = depts.map((row) => ({
                    value: row.id,
                    text: row.name,
                }))
                this.category_options.unshift({ value: 'all', text: 'All departments' })
            } catch (error) {
                console.error("Error fetching categories:", error)
                this.category_data = []
                this.category_options = [{ value: 'all', text: 'All departments' }]
            }
        },
        syncDepartmentFromRoute() {
            const w = this.$route.query.web_category
            if (w == null || w === '') {
                this.category_value = 'all'
                return
            }
            const raw = Array.isArray(w) ? w[0] : w
            this.category_value = String(raw ?? 'all')
        },
        /** When department changes on /shop, clear nested filters that belong to another department. */
        applyDepartmentToShopRoute(value) {
            const v = value === 'all' || value == null || value === ''
                ? null
                : String(value)

            const next = { ...this.$route.query }
            if (!v) {
                delete next.web_category
            } else {
                next.web_category = v
            }
            delete next.category
            delete next.category_child
            delete next.sub_category
            delete next.brand

            this.$router
                .push({ name: 'Shop', query: next })
                .catch(() => {})
        },
        changeHandler(item) {
            const v = item?.value != null ? item.value : item
            this.category_value = v
            if (this.$route.name === 'Shop') {
                this.applyDepartmentToShopRoute(v)
            }
        },

        normalizeSuggestionRows(payload) {
            if (Array.isArray(payload)) return payload
            if (payload && Array.isArray(payload.data)) return payload.data
            if (payload && Array.isArray(payload.rows)) return payload.rows
            return []
        },
        async fetchSuggestions(q) {
            try {
                const query = String(q ?? '').trim()
                if (!query) {
                    this.suggestions = []
                    this.showSuggestions = false
                    this.suggestIndex = -1
                    return
                }
                const params = { q: query, limit: 10 }
                const wc =
                  this.category_value != null &&
                  this.category_value !== '' &&
                  this.category_value !== 'all'
                    ? String(this.category_value)
                    : ''
                if (wc) params.web_category = wc
                const res = await this.$axios.get('/shop-product-suggestions', { params })
                const rows = this.normalizeSuggestionRows(res.data)
                this.suggestions = rows
                this.showSuggestions = rows.length > 0
                this.suggestIndex = rows.length ? 0 : -1
            } catch (e) {
                this.suggestions = []
                this.showSuggestions = false
                this.suggestIndex = -1
            }
        },
        handleSuggestInput() {
            if (this.suggestTimer) clearTimeout(this.suggestTimer)
            this.suggestTimer = setTimeout(() => {
                this.fetchSuggestions(this.searchText)
            }, 180)
        },
        handleSuggestFocus() {
            if (this.searchText) {
                this.fetchSuggestions(this.searchText)
            }
        },
        handleSuggestBlur() {
            // Allow mousedown on suggestions (clicks) before hiding — 150ms was tight on some devices
            setTimeout(() => {
                this.showSuggestions = false
            }, 220)
        },
        suggestMove(delta) {
            if (!this.showSuggestions || !this.suggestions.length) return
            const n = this.suggestions.length
            let next = this.suggestIndex + delta
            if (next < 0) next = n - 1
            if (next >= n) next = 0
            this.suggestIndex = next
        },
        selectSuggestion(s) {
            if (!s) return
            this.showSuggestions = false
            // Open the exact web product (same id as /web-product/{id}/details)
            const pid = s.id ?? s.web_product_id
            if (pid != null && pid !== '') {
                this.$router.push({ path: `/product-details/${pid}` }).catch(() => {})
                return
            }
            this.searchText = s.product_name || this.searchText
            this.handleSubmit()
        },
        handleEnterFromSuggest() {
            if (this.showSuggestions && this.suggestions.length && this.suggestIndex >= 0) {
                return this.selectSuggestion(this.suggestions[this.suggestIndex])
            }
            this.handleSubmit()
        },

        handleSubmit() {
            const dept =
                this.category_value != null &&
                this.category_value !== '' &&
                this.category_value !== 'all'
                    ? String(this.category_value)
                    : ''
            const q = String(this.searchText ?? '').trim()

            if (this.$route.name === 'Shop') {
                const query = { ...this.$route.query }
                if (q) query.searchText = q
                else delete query.searchText
                if (dept) query.web_category = dept
                else delete query.web_category
                this.$router.push({ name: 'Shop', query }).catch(() => {})
                return
            }

            const query = {}
            if (q) query.searchText = q
            if (dept) query.web_category = dept
            this.$router.push({ name: 'Shop', query }).catch(() => {})
        }
    },
    watch: {
        '$route.fullPath'() {
            this.syncDepartmentFromRoute()
        },
    },
    mounted() {
        this.syncDepartmentFromRoute()
        this.fetchCategories().then(() => this.syncDepartmentFromRoute())
    }
}
</script>


<style>
:root {
    --shop-header-icon-box: 66px;
    /* Caps for shop PNG (wide canvas + left graphic); tuned in one place for SCSS + Vue. */
    --shop-header-logo-height: 122px;
    --shop-header-logo-max-width: 720px;
    /* Unified corner round on search shell + category + suggestions */
    --shop-search-radius: 10px;
}

/* —— Shop header row (logo · search · account · theme · cart) —— */
.header-mid--shop {
    background: #fafbfc;
    border-bottom: 1px solid rgba(15, 23, 42, 0.06);
    box-shadow: 0 1px 0 rgba(255, 255, 255, 0.9) inset;
}

.header-mid-inner--shop {
    border-bottom: none !important;
    padding: 1rem 0 1.125rem !important;
    position: relative !important;
    z-index: 2 !important;
}

.header-mid--shop .logo .logo-image {
    display: block;
    line-height: 0;
}

.header-mid--shop .logo .logo-image img {
    height: auto;
    max-height: var(--shop-header-logo-height);
    max-width: min(100%, var(--shop-header-logo-max-width));
    width: auto;
    object-fit: contain;
    object-position: left center;
    display: block;
}

@media (max-width: 1199px) {
    .header-mid--shop .logo .logo-image img {
        max-height: 90px;
        max-width: min(100%, 380px);
    }
}

@media (max-width: 767px) {
    .header-mid--shop .logo .logo-image img {
        max-height: 68px;
        max-width: min(100%, 290px);
    }
}

/* Search: clear elevation so users notice it on white header (layered shadow) */
.header-mid--shop .header__search {
    margin-left: 0;
    position: relative;
}

/* Search bar: rounded shell (four corners), crisp border, flat segments */
.header-mid--shop .header__search-box {
    border: 1px solid #64748b !important;
    border-radius: var(--shop-search-radius) !important;
    overflow: hidden;
    background: #ffffff;
    position: relative;
    z-index: 1;
    box-shadow:
        inset 0 1px 0 rgba(255, 255, 255, 0.85),
        0 1px 3px rgba(15, 23, 42, 0.12),
        0 2px 8px rgba(15, 23, 42, 0.06);
    transition: box-shadow 0.18s ease, border-color 0.18s ease;
}

.header-mid--shop .header__search-box:hover {
    border-color: #475569 !important;
    box-shadow:
        inset 0 1px 0 rgba(255, 255, 255, 0.9),
        0 2px 4px rgba(15, 23, 42, 0.14),
        0 4px 14px rgba(15, 23, 42, 0.08);
}

.header-mid--shop .header__search-box:focus-within {
    border-color: var(--fe-accent, #fcbe00) !important;
    box-shadow:
        inset 0 1px 0 rgba(255, 255, 255, 0.95),
        0 0 0 2px rgba(252, 190, 0, 0.35),
        0 2px 6px rgba(15, 23, 42, 0.12);
}

.header-mid--shop .header__search-box .search-input {
    border: none !important;
    height: 48px !important;
    line-height: 48px !important;
    border-radius: 0 !important;
    background: #fff !important;
    font-family: 'Inter', 'Segoe UI', system-ui, -apple-system, sans-serif !important;
    font-size: 14px !important;
    font-weight: 400 !important;
    letter-spacing: 0.005em;
    color: #374151 !important;
}

.header-mid--shop .header__search-box .search-input::placeholder {
    color: #64748b !important;
    font-weight: 500 !important;
    font-size: 14px !important;
    font-style: normal !important;
    letter-spacing: 0.02em !important;
}

.header-mid--shop .header__search-box .search-input:focus {
    border: none !important;
    outline: none !important;
}

.header-mid--shop .header__search-box .button {
    height: 48px !important;
    min-width: 52px !important;
    line-height: 48px !important;
    padding: 0 16px !important;
    display: flex !important;
    align-items: center;
    justify-content: center;
    background: var(--fe-accent, #fcbe00) !important;
    color: #fff !important;
    border: none !important;
    border-radius: 0 var(--shop-search-radius) var(--shop-search-radius) 0 !important;
    border-left: 1px solid rgba(15, 23, 42, 0.12) !important;
    top: 0 !important;
    font-size: 18px !important;
    box-shadow: inset 0 1px 0 rgba(255, 255, 255, 0.2);
    transition: filter 0.15s ease, transform 0.1s ease;
}

.header-mid--shop .header__search-box .button:hover {
    filter: brightness(1.05);
}

.header-mid--shop .header__search-box .button:active {
    transform: scale(0.98);
}

/* Category panel carries the right edge (border); hide legacy ::before so we don’t double the rule */
.header-mid--shop .header__search-box::before {
    display: none !important;
}

/* —— Search suggestions dropdown (typeahead) —— */
.header-search-suggestions {
    position: absolute;
    left: 0;
    right: 0;
    top: calc(100% + 6px);
    background: #ffffff;
    border: 1px solid #64748b;
    border-radius: var(--shop-search-radius);
    box-shadow: 0 8px 24px rgba(15, 23, 42, 0.12), 0 2px 6px rgba(15, 23, 42, 0.08);
    overflow: hidden;
    z-index: 9999;
    max-height: 340px;
    overflow-y: auto;
}
.header-search-suggestions .suggestion-item {
    padding: 10px 12px;
    cursor: pointer;
    border-bottom: 1px solid rgba(15, 23, 42, 0.06);
}
.header-search-suggestions .suggestion-item:last-child {
    border-bottom: none;
}
.header-search-suggestions .suggestion-item:hover,
.header-search-suggestions .suggestion-item.active {
    background: rgba(252, 190, 0, 0.14);
}
.header-search-suggestions .suggestion-title {
    font-weight: 800;
    color: rgba(15, 23, 42, 0.92);
    font-size: 13px;
    line-height: 1.2;
}
.header-search-suggestions .suggestion-sub {
    margin-top: 2px;
    font-size: 12px;
    color: rgba(15, 23, 42, 0.60);
}

/* Category lane: outer-left corners match search shell */
.header-mid--shop .header__search-cat .nice-select {
    font-family: 'Inter', 'Segoe UI', system-ui, -apple-system, sans-serif !important;
    font-weight: 500 !important;
    font-size: 13px !important;
    color: #334155 !important;
    letter-spacing: 0.025em;
    background: #ffffff !important;
    border: none !important;
    border-radius: var(--shop-search-radius) 0 0 var(--shop-search-radius) !important;
    height: 48px !important;
    line-height: 46px !important;
    padding-left: 2px !important;
    padding-right: 22px !important;
    border-right: 1px solid #94a3b8 !important;
    box-shadow: none !important;
}

.header-mid--shop .header__search-cat .nice-select .current {
    font-weight: 400 !important;
    color: #4b5563 !important;
}

.header-mid--shop .header__search-cat .nice-select .list .option {
    font-family: 'Inter', 'Segoe UI', system-ui, -apple-system, sans-serif !important;
    font-weight: 400 !important;
    font-size: 14px !important;
    color: #4b5563;
}

.header-mid--shop .header__search-cat .nice-select .list .option.selected {
    font-weight: 500 !important;
}

/* Actions: spacing + hover affordance */
.header-action--shop .icon-link span {
    color: var(--fe-text-on-light, #3d4a5c);
}

.header-action--shop .icon-link i {
    color: var(--fe-text-on-light, #3d4a5c);
}

.header-action--shop .icon-link .sub {
    color: var(--fe-text-muted-on-light, #6b7688);
    font-size: 12px;
    letter-spacing: 0.01em;
}

.header-action--shop .icon-link i.flaticon-user,
.header-action--shop .icon-link i.flaticon-shopping-bag {
    color: var(--fe-text-on-light, #3d4a5c);
    font-size: 38px !important;
    width: var(--shop-header-icon-box);
    height: var(--shop-header-icon-box);
    min-width: var(--shop-header-icon-box);
    line-height: var(--shop-header-icon-box);
    display: inline-flex;
    align-items: center;
    justify-content: center;
}

/* —— Line-art cart icon + red count badge (matches the requested mockup) —— */
.shop-cart-svg-wrap {
    position: relative;
    display: inline-flex;
    align-items: center;
    justify-content: center;
    width: var(--shop-header-icon-box);
    height: var(--shop-header-icon-box);
    min-width: var(--shop-header-icon-box);
    margin-right: 10px;
    flex-shrink: 0;
}

.shop-cart-svg {
    width: 38px;
    height: 38px;
    color: var(--fe-text-on-light, #1f2937);
    transition: color 0.18s ease, transform 0.18s ease;
}

.icon-link--cart:hover .shop-cart-svg {
    color: var(--fe-secondary, var(--fe-accent, #2563eb));
    transform: translateY(-1px);
}

.shop-cart-badge {
    position: absolute;
    top: 6px;
    right: 8px;
    min-width: 20px;
    height: 20px;
    padding: 0 5px;
    border-radius: 999px;
    background: #e11d48;
    color: #ffffff !important;
    font-family: 'Inter', 'Segoe UI', system-ui, -apple-system, sans-serif;
    font-size: 11px;
    font-weight: 600;
    line-height: 20px;
    text-align: center;
    box-shadow: 0 1px 3px rgba(15, 23, 42, 0.18);
    pointer-events: none;
}

/* Welcome user line — clean and visible, NOT bold; username adopts the active theme color */
.welcome-text {
    color: var(--fe-text-on-light, #374151) !important;
    font-family: 'Inter', 'Segoe UI', system-ui, -apple-system, sans-serif;
    font-weight: 500 !important;
    font-size: 14px !important;
    letter-spacing: 0.01em;
    line-height: 1.3;
    display: inline-flex;
    flex-direction: column;
}

.welcome-text .sub {
    font-weight: 400 !important;
    font-size: 12px !important;
    color: var(--fe-text-muted-on-light, #6b7280) !important;
    letter-spacing: 0.02em;
    margin-bottom: 1px;
}

.welcome-text .welcome-username {
    font-weight: 500 !important;
    font-size: 14px !important;
    color: var(--fe-secondary, #2563eb) !important;
    letter-spacing: 0.005em;
    line-height: 1.2;
    max-width: 9.5rem;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
}

/* Cart text — same scale & font as Welcome user, never bold, theme-coloured amount */
.cart-text {
    color: var(--fe-text-on-light, #374151) !important;
    font-family: 'Inter', 'Segoe UI', system-ui, -apple-system, sans-serif;
    font-weight: 500 !important;
    font-size: 14px !important;
    letter-spacing: 0.01em;
    line-height: 1.3;
    display: inline-flex;
    flex-direction: column;
}

.cart-text .sub {
    font-weight: 400 !important;
    font-size: 12px !important;
    color: var(--fe-text-muted-on-light, #6b7280) !important;
    letter-spacing: 0.02em;
    margin-bottom: 1px;
    text-transform: none;
}

.cart-text .cart-amount {
    font-weight: 500 !important;
    font-size: 14px !important;
    color: var(--fe-secondary, #2563eb) !important;
    letter-spacing: 0.005em;
    line-height: 1.2;
    font-variant-numeric: tabular-nums;
    white-space: nowrap;
}

.header-action--shop .icon-link .count {
    background: var(--fe-accent, #fcbe00) !important;
    color: #fff !important;
    font-weight: 700;
    border: 2px solid #fff !important;
    box-shadow: 0 2px 6px rgba(15, 23, 42, 0.12);
    min-width: 22px;
}

.header-action--shop .icon-link {
    padding: 0.4rem 0.55rem;
    border-radius: 12px;
    transition: background 0.2s ease, box-shadow 0.2s ease;
}

.header-action--shop .icon-link:hover {
    background: rgba(15, 23, 42, 0.04);
    box-shadow: none;
}

/* Actions column: allow flex children to shrink without forcing row wrap */
.header-mid__actions-col {
    min-width: 0;
}

.header-action--with-theme {
    display: flex;
    align-items: center;
    justify-content: flex-end;
    width: 100%;
    min-width: 0;
    gap: 0.35rem 0.65rem;
    flex-wrap: nowrap;
}

.header-action--with-theme .block-userlink,
.header-action--with-theme .block-cart,
.header-action--with-theme .header-action__theme-center {
    flex: 0 0 auto;
}

.header-action__theme-center {
    display: flex;
    justify-content: center;
    align-items: center;
}

/* Keep profile + cart links horizontal (icon | text); long prices stay on one logical row */
.header-action--with-theme .icon-link {
    display: inline-flex !important;
    align-items: center;
    max-width: 100%;
    min-width: 0;
}

.header-action--with-theme .block-cart .icon-link .text {
    min-width: 0;
    font-variant-numeric: tabular-nums;
}

.header-action--with-theme .block-userlink .icon-link .text {
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
    max-width: 9.5rem;
}

@media (max-width: 991px) {
    .header-mid-inner--shop {
        padding: 0.75rem 0 !important;
    }
}

/* —— Sticky header: keeps top-bar + logo/search row + nav bar pinned while the page scrolls —— */
.header.d-blue-bg {
    position: sticky;
    top: 0;
    z-index: 1000;
    box-shadow: 0 2px 12px rgba(15, 23, 42, 0.08);
    transition: box-shadow 0.25s ease;
}

/*
 * Shrunk sticky header: never transition padding/font-size/max-height on the pinned block —
 * those repaint reflow chains while scrolling feel like the whole page is shaking.
 * Keep only paint-only transitions (shadow, border, color).
 */
.header.d-blue-bg .header-mid-inner--shop,
.header.d-blue-bg .header__bottom,
.header.d-blue-bg .logo .logo-image img,
.header.d-blue-bg .header__search-box,
.header.d-blue-bg .header__search-box .search-input,
.header.d-blue-bg .header__search-box .button,
.header.d-blue-bg .shop-cart-svg,
.header.d-blue-bg .shop-cart-svg-wrap,
.header.d-blue-bg .header-action--shop .icon-link i.flaticon-user {
    transition: box-shadow 0.22s ease, border-color 0.2s ease, background-color 0.2s ease, color 0.18s ease;
}

.header.d-blue-bg .header-top {
    transition: box-shadow 0.2s ease, border-color 0.2s ease;
}

.header.d-blue-bg .header-top p,
.header.d-blue-bg .header-top a,
.header.d-blue-bg .ovic-menu-wrapper li a {
    transition: color 0.18s ease, background-color 0.18s ease;
}

/* —— Shrunk state (after scroll): less padding, smaller logo, denser nav —— */
.header.d-blue-bg.header--shrunk {
    box-shadow: 0 4px 16px rgba(15, 23, 42, 0.12);
}

/* Compact the top utility bar instead of collapsing it to zero height.
   Full collapse caused large layout shifts + sticky “jump” while scrolling. */
.header.d-blue-bg.header--shrunk .header-top {
    padding-top: 5px !important;
    padding-bottom: 5px !important;
}

.header.d-blue-bg.header--shrunk .header-top p,
.header.d-blue-bg.header--shrunk .header-top a,
.header.d-blue-bg.header--shrunk .ovic-menu-wrapper li a {
    font-size: 12px !important;
    line-height: 1.25 !important;
}

.header.d-blue-bg.header--shrunk .header-mid-inner--shop {
    padding: 0.45rem 0 0.5rem !important;
}

.header.d-blue-bg.header--shrunk .logo .logo-image img {
    height: auto;
    max-height: 96px !important;
    max-width: min(100%, 400px) !important;
    object-position: left center;
}

@media (max-width: 1199px) {
    .header.d-blue-bg.header--shrunk .logo .logo-image img {
        max-height: 76px !important;
        max-width: min(100%, 320px) !important;
    }
}

@media (max-width: 767px) {
    .header.d-blue-bg.header--shrunk .logo .logo-image img {
        max-height: 58px !important;
        max-width: min(100%, 260px) !important;
    }
}

.header.d-blue-bg.header--shrunk .header__search-box {
    box-shadow:
        inset 0 1px 0 rgba(255, 255, 255, 0.85),
        0 1px 2px rgba(15, 23, 42, 0.1),
        0 2px 6px rgba(15, 23, 42, 0.06) !important;
}

.header.d-blue-bg.header--shrunk .header__search-box .search-input,
.header.d-blue-bg.header--shrunk .header__search-box .button {
    height: 40px !important;
    line-height: 40px !important;
}

.header.d-blue-bg.header--shrunk .header__search-cat .nice-select {
    height: 40px !important;
    line-height: 38px !important;
}

.header.d-blue-bg.header--shrunk .header-action--shop .icon-link i.flaticon-user {
    font-size: 30px !important;
    width: 50px;
    height: 50px;
    min-width: 50px;
    line-height: 50px;
}

.header.d-blue-bg.header--shrunk .shop-cart-svg-wrap {
    width: 50px;
    height: 50px;
    min-width: 50px;
}

.header.d-blue-bg.header--shrunk .shop-cart-svg {
    width: 30px;
    height: 30px;
}

.header.d-blue-bg.header--shrunk .welcome-text,
.header.d-blue-bg.header--shrunk .cart-text {
    font-size: 13px !important;
}

.header.d-blue-bg.header--shrunk .welcome-text .sub,
.header.d-blue-bg.header--shrunk .cart-text .sub {
    font-size: 11px !important;
}

.header.d-blue-bg.header--shrunk .welcome-text .welcome-username,
.header.d-blue-bg.header--shrunk .cart-text .cart-amount {
    font-size: 13px !important;
}

.header.d-blue-bg.header--shrunk .header__bottom {
    padding-top: 0;
    padding-bottom: 0;
}

.header.d-blue-bg.header--shrunk .main-menu nav > ul > li > a {
    padding: 9px 18px !important;
    font-size: 13px !important;
}

.header.d-blue-bg.header--shrunk .cat-toggle-btn,
.header.d-blue-bg.header--shrunk .cat-toggle-btn-1 {
    padding-top: 8px !important;
    padding-bottom: 8px !important;
}

/* —— Nav menu: HOME / ABOUT US / PRODUCTS / CONTACT US distributed with
       perfectly equal spacing across the whole nav row. —— */
.header.d-blue-bg .header__bottom-left,
.header.d-blue-bg .main-menu {
    width: 100%;
}

.header.d-blue-bg .main-menu nav,
.header.d-blue-bg .main-menu nav > ul {
    width: 100%;
}

.header.d-blue-bg .main-menu nav > ul {
    display: flex;
    align-items: center;
    justify-content: space-evenly;
    flex-wrap: nowrap;
    gap: 0;
    margin: 0;
    padding: 0;
    list-style: none;
}

.header.d-blue-bg .main-menu nav > ul > li {
    display: inline-flex;
    align-items: center;
    flex: 0 0 auto;
    margin: 0 !important;
    padding: 0;
}

.header.d-blue-bg .main-menu nav > ul > li > a {
    display: inline-flex;
    align-items: center;
    padding: 14px 22px;
    font-size: 14px;
    font-weight: 600;
    letter-spacing: 0.06em;
    line-height: 1.1;
    color: #ffffff;
    text-transform: uppercase;
    transition: color 0.18s ease, background-color 0.18s ease;
    border-radius: 6px;
}

.header.d-blue-bg .main-menu nav > ul > li > a:hover,
.header.d-blue-bg .main-menu nav > ul > li > a.active {
    color: #ffffff;
    background: rgba(255, 255, 255, 0.18);
}

@media (max-width: 1199px) {
    .header.d-blue-bg .main-menu nav > ul > li > a {
        padding: 12px 16px;
        font-size: 13px;
    }
}

@media (max-width: 991px) {
    .header.d-blue-bg .main-menu nav > ul {
        flex-wrap: wrap;
        justify-content: flex-start;
    }
    .header.d-blue-bg .main-menu nav > ul > li > a {
        padding: 10px 14px;
    }
}

/* Global header SCSS forces .icon-link { display: block } on very narrow widths — keep shop row horizontal */
@media only screen and (min-width: 320px) and (max-width: 370px) {
    .header-action--shop.header-action--with-theme .icon-link {
        display: inline-flex !important;
        flex-direction: row !important;
    }
}
</style>